<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                 
                    <h2 >
                        <h2> चालान क्या है? </h2>
                    </h2>
                </div>

                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a></div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='36'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="37">


                    <label for="" class="mt-2" >चालान एक व्यापारी द्वारा ग्राहक को भेजा
                        गया एक औपचारिक दस्तावेज है, जो प्रदान किए गए उत्पादों या सेवाओं के लिए
                        भुगतान का अनुरोध करता है। यह ई-कॉमर्स की दुनिया में एक आवश्यक उपकरण है, जो
                        कई महत्वपूर्ण कार्य करता है। </label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="38">
                    <h2 >चालान के कार्य </h2>
                
                    <ul >
                        <li class="mt-3"><b>रिकॉर्ड रखना: </b>&nbsp; चालान सभी लेनदेन का एक स्पष्ट
                            रिकॉर्ड प्रदान करते हैं, यह सुनिश्चित करते हुए कि दोनों पक्षों के पास
                            आदान-प्रदान किए गए उत्पादों या सेवाओं का विस्तृत खाता है। </li>

                        <li class="mt-3"><b> भुगतान अनुरोध: </b>&nbsp; चालान भुगतान के लिए एक विनम्र
                            लेकिन दृढ़ अनुरोध के रूप में कार्य करते हैं। वे देय राशि, भुगतान की
                            शर्तों और स्वीकृत भुगतान विधियों के बारे में बताते हैं। </li>


                        <li class="mt-3"><b> व्यावसायिकता: </b>&nbsp; पेशेवर, अच्छी तरह से डिज़ाइन
                            किए गए चालान आपके ग्राहकों को विश्वास और विश्वसनीयता प्रदान करते हैं,
                            जिससे आपकी ब्रांड छवि बढ़ती है।
                        </li>


                        <li class="mt-3"><b> कानूनी सुरक्षा: </b>&nbsp;विवादों या ऑडिट के मामले में
                            चालान कानूनी दस्तावेज के रूप में काम कर सकते हैं, जो व्यापारियों और
                            ग्राहकों दोनों को सुरक्षा प्रदान करते हैं। </li>

                    </ul>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="39">
                    <h2 > पे जी के साथ चालान का उपयोग क्यों करें? </h2>
             
                    <label for="" class="mt-3" >जब आप पे जी के माध्यम से चालान को अपनी
                        भुगतान प्रक्रिया में एकीकृत करते हैं, तो आप कई प्रकार के लाभों को अनलॉक करते
                        हैं जो आपके भुगतान प्रबंधन में उल्लेखनीय सुधार कर सकते हैं: </label>

                
                    <ul >
                        <li class="mt-3">
                            दक्षता: पे जी की चालान सुविधा के साथ, आप आसानी से चालान बना सकते हैं, भेज
                            सकते हैं और ट्रैक कर सकते हैं। मैन्युअल चालान तैयार करने और ट्रैकिंग को
                            अलविदा कहें; हमारा सिस्टम आपके लिए यह सब स्वचालित करता है।
                        </li>
                        <li class="mt-3">
                            अनुकूलन: अपने ब्रांड की पहचान से मेल खाने के लिए अपने चालान तैयार करें।
                            अपना लोगो जोड़ें, रंग चुनें और अपने पसंदीदा इनवॉइस टेम्पलेट का उपयोग
                            करें।
                        </li>
                        <li class="mt-3">
                            भुगतान विकल्प: अपने ग्राहकों को कई भुगतान विधियाँ प्रदान करें, जिससे
                            उनके लिए अपने बिलों का निपटान करना आसान हो जाए। पे जी के साथ, आप क्रेडिट
                            कार्ड, डिजिटल वॉलेट और बहुत कुछ स्वीकार कर सकते हैं।
                        </li>

                        <li class="mt-3">
                            स्वचालित अनुस्मारक: देर से भुगतान के बारे में फिर कभी चिंता न करें। पे जी
                            आपके ग्राहकों को स्वचालित भुगतान अनुस्मारक भेज सकता है, देर से भुगतान को
                            कम कर सकता है और नकदी प्रवाह में सुधार कर सकता है।
                        </li>

                        <li class="mt-3">
                            विस्तृत रिपोर्टिंग: अपनी चालान गतिविधि पर व्यापक रिपोर्ट तक पहुंचें,
                            जिससे आपको अपने व्यवसाय के वित्तीय स्वास्थ्य के बारे में जानकारी प्राप्त
                            करने में मदद मिलेगी।
                        </li>


                    </ul>
                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
                    (mouseout)="showpayment(false,'5')" id="40">
                    <h2 >पे जी पर चालान के साथ शुरुआत करना </h2>

                    
                    <h5 class="mt-3" >
                        अपने पे जी खाते में लॉगिन करें
                    </h5>
                    <br>
                    <label for="" class="mt-1" > यदि आपने पहले से नहीं किया है, तो अपने
                        पे जी मर्चेंट खाते में लॉग इन करें।
                    </label>
                    <img src="./assets/Invoice1.png" alt="" width="100%" height="30%" class="mt-2">

                  
                    <h5 class="mt-3" >
                        प्रवेश चालान
                    </h5>
                    <br>
                    <label for="" class="mt-1" > अपने खाते के डैशबोर्ड में चालान अनुभाग
                        पर जाएँ।
                    </label>
                    <img src="./assets/Invoice2.png" alt="" width="100%" height="10%" class="mt-2">
                    
                    <h5 class="mt-3" >
                        एक चालान बनाएं
                    </h5>
                    <br>
                    <label for="" class="mt-1" > नया इनवॉइस बनाने के लिए हमारे
                        उपयोगकर्ता-अनुकूल इंटरफ़ेस का पालन करें। ग्राहक की जानकारी, उत्पाद या सेवा
                        विवरण, कीमतें और देय तिथियों सहित आवश्यक विवरण भरें। </label>
                    <img src="./assets/Invoice3.png" alt="" width="100%" height="30%" class="mt-2">


                   
                    <h5 class="mt-3" >
                        चालान भेजें
                    </h5>
                    <br>
                    <label for="" class="mt-1" > एक बार जब आपका चालान तैयार हो जाए, तो
                        बस "भेजें" बटन दबाएं। पे जी इसे आपके ग्राहक के ईमेल पते पर वितरित करेगा।
                    </label>
                    <img src="./assets/Invoice4.png" alt="" width="80%" height="20%" class="mt-2">

                    
                    <h5 class="mt-3" >
                        भुगतान ट्रैक करें और प्राप्त करें
                    </h5>
                    <br>
                    <label for="" class="mt-1" >वास्तविक समय में अपने चालान की स्थिति
                        की निगरानी करें। पे जी के भुगतान प्रसंस्करण समाधानों के माध्यम से सुरक्षित
                        रूप से भुगतान प्राप्त करें। </label>
                    <img src="./assets/Invoice5.png" alt="" width="100%" height="10%" class="mt-2">
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                   
                    <h5 >
                        विषयसूची
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
                   <a href="#36">  <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Invoice </span>
                        </div>
                    </div><a?
                </div> -->

                <div class="col-md-12 mt-2">
                    <a href="#37">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >
                                    चालान का परिचय </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#38">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >चालान के कार्य </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#39">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    पे जी के साथ चालान का उपयोग क्यों करें? </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#40">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >चालान बनाना </span>
                            </div>
                        </div>
                    </a>
                </div>



            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
               
                <a [routerLink]="['/payment-qr']"> <button class="btn btn-color" (click)="menues('Payment QR')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;पेमेंट क्यूआर

                </button></a>
            </div>
            <div class="col-md-4    ">
                
                <a [routerLink]="['/video-kyc']"> <button class="btn btn-color" (click)="menues('Video KYC')" >वीडियो
                    केवाईसी
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>